import { yupResolver } from '@hookform/resolvers/yup'
import type { FieldValues, Resolver } from 'react-hook-form'
import type { AnyObjectSchema } from 'yup'

export const yupFormResolver = <T extends FieldValues>(schema: AnyObjectSchema): Resolver<T> =>
  yupResolver(schema) as unknown as Resolver<T>
